/* eslint-disable react/prop-types */
import { useState } from "react";
import SoftBox from "components/SoftBox";
import { Icon, Menu, MenuItem } from "@mui/material";
import { Link } from "react-router-dom";
import journalVoucher6Service from "services/journal-voucher-6";
import { toast } from "react-toastify";

function ActionCell({ item, setDataTable }) {
  const [anchorEl, setAnchorEl] = useState(null);

  const handleOpenMenu = (event) => setAnchorEl(event.currentTarget);
  const handleCloseMenu = () => setAnchorEl(null);

  const handleDelete = async () => {
    if (window.confirm("Bạn có chắc chắn muốn xóa Nhật ký chứng từ này?")) {
      try {
        await journalVoucher6Service.delete(item.id);
        toast.success("Xóa thành công!");
        setDataTable((prev) => ({
          ...prev,
          rows: prev.rows.filter((row) => row.id !== item.id),
        }));
      } catch (error) {
        console.error("Lỗi khi xóa:", error);
        toast.error("Xóa thất bại!");
      }
    }
    handleCloseMenu();
  };

  return (
    <SoftBox display="flex" alignItems="center">
      <SoftBox color="secondary" sx={{ cursor: "pointer", lineHeight: 0 }} onClick={handleOpenMenu}>
        <Icon sx={{ fontWeight: "bold" }}>more_vert</Icon>
      </SoftBox>
      <Menu anchorEl={anchorEl} open={Boolean(anchorEl)} onClose={handleCloseMenu} keepMounted>
        <MenuItem component={Link} to={`/templates/journal-voucher-6/view/${item.id}`}>
          Xem chi tiết
        </MenuItem>
        {!item.autoMapped && (
          <>
            <MenuItem component={Link} to={`/templates/journal-voucher-6/edit/${item.id}`}>
              Chỉnh sửa
            </MenuItem>
            <MenuItem onClick={handleDelete} sx={{ color: "error.main" }}>
              Xóa
            </MenuItem>
          </>
        )}
      </Menu>
    </SoftBox>
  );
}

export default ActionCell;
